import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { bindMenu, PopupState } from 'material-ui-popup-state/hooks';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  children: ReactNode;
  popupState: PopupState;
  width?: number;
  'data-tour'?: string;
}

const FiltersPopover = ({ children, popupState, width = 400, 'data-tour': dataTour }: Props) => {
  const { t } = useTranslation();

  return (
    <Popover
      {...bindMenu(popupState)}
      keepMounted
      slotProps={{
        paper: {
          style: { width },
          ...(dataTour ? { 'data-tour': dataTour } as Record<string, string> : {}),
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <Box
        sx={{
          alignItems: 'center',
          borderBottom: 1,
          borderColor: 'divider',
          display: 'flex',
          justifyContent: 'space-between',
          px: 2,
          py: 1,
        }}
      >
        <Typography component="h2" variant="subtitle2">
          {t('form.filters')}
        </Typography>
        <IconButton aria-label={t('base.close')} onClick={() => popupState.close()} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      {children}
    </Popover>
  );
};

export default FiltersPopover;
